var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as t from 'io-ts';
export function pick(type, keys, name) {
    return t.type(Object.assign.apply(Object, __spreadArray([{}], keys.map(function (key) {
        var _a;
        return (_a = {}, _a[key] = type.props[key], _a);
    }), false)), name !== null && name !== void 0 ? name : type.name);
}
